function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { Button, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import uniqueId from 'lodash.uniqueid';
import Dialog from '../Dialog';
import PrimaryButton from '../PrimaryButton';

const ConfirmationDialog = ({
  cancelButtonText,
  confirmationButtonText,
  onClose,
  onConfirmation,
  text,
  title,
  ...props
}) => {
  const dialogId = uniqueId('confirmationDialog_');
  return React.createElement(Dialog, _extends({}, props, {
    onClose: onClose,
    "aria-labelledby": dialogId
  }), React.createElement(DialogTitle, {
    id: dialogId
  }, title), React.createElement(DialogContent, null, React.createElement(DialogContentText, null, text)), React.createElement(DialogActions, null, React.createElement(PrimaryButton, {
    onClick: e => {
      e.stopPropagation();
      onConfirmation();
      onClose(e);
    },
    autoFocus: true
  }, confirmationButtonText), React.createElement(Button, {
    onClick: e => {
      e.stopPropagation();
      onClose(e);
    },
    color: "primary"
  }, cancelButtonText)));
};

ConfirmationDialog.propTypes = {
  cancelButtonText: PropTypes.string,
  confirmationButtonText: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onConfirmation: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  title: PropTypes.string
};
ConfirmationDialog.defaultProps = {
  cancelButtonText: 'Cancel',
  confirmationButtonText: 'Ok',
  title: 'Please Confirm'
};
export default ConfirmationDialog;